import { ChangeEvent, Dispatch, useState } from "react"
import '../components.scss'

type InputProps = {
    label: string,
    value: string,
    setValue: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    type: string,
    required?: boolean,
    disabled?: boolean
    errorMessage: string
}

export const Input = ({ label, required, disabled, errorMessage, value, type, setValue }: InputProps) => {


    return (
        <div className="input">
            {label.length > 0
                ?  
                    <div className="input__left">
                        <label className="input__left__label">{label}{required ? <span className="input__left__required">*</span> : ""}</label>
                    </div>
                : ''
            }
            <div className="input__right">
                {{
                    'textarea':
                        <textarea
                            className={'input__right__textarea' + (errorMessage.length > 0 ? ' invalid' : '')}
                            onChange={setValue}
                            value={value}
                            disabled={disabled}
                        ></textarea>
                }[type] || <input
                        className={'input__right__input' + (errorMessage.length > 0 ? ' invalid' : '')}
                        type={type}
                        onChange={setValue}
                        value={value}
                        disabled={disabled}
                    />
                }
                
                {errorMessage.length > 0
                    ? <div className="input__right__error">{errorMessage}</div>
                    : ""
                }

            </div>
        </div>
    )
}